import { render } from "./sales-history.vue?vue&type=template&id=59b0c371"
import script from "./sales-history.vue?vue&type=script&lang=js"
export * from "./sales-history.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__